var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#32325D",
    d: "M6.875 0h-5.5C.619 0 .007.63.007 1.4L0 12.6c0 .77.612 1.4 1.368 1.4h8.257c.756 0 1.375-.63 1.375-1.4V4.2L6.875 0zm-5.5 12.6V1.4h4.813v3.5h3.437v7.7h-8.25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file_icon.e7b6e42ebe56f06ca41ba2e5ede86cd3.svg";
export { ForwardRef as ReactComponent };